export default function addDisplayPostfix() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $ngModel.$formatters.push((value) => (value ? `${value}${$attrs.addDisplayPostfix}` : value));
    },
  };
}
